export const Colors = Object.freeze({
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  BROWN: 'brown',
  YELLOW: 'yellow',
  PINK: 'pink',
  VIOLET: 'violet',
  ORANGE: 'primary-2',
  CHARDONNAY: 'chardonnay',
  RED: 'primary-4',
  GRAY: 'gray-11',
});

export const compensatoryRequestType = Object.freeze({
  Reposicion: 1,
  Regresion: 2,
});

export const compensatoryServiceStatus = Object.freeze({
  Nuevo: 1,
  Aprobado: 2,
  Denegado: 3,
  AprobadoModificado: 4,
  Sometido: 5,
  ProcesoCompletado: 6,
  SolicitudRechazada: 7,
  CompletadoPendienteAprobacion: 8,
  DevueltoAProveedor: 9,
  ExcluidoPorEstrategia: 10,
  ExcluidoEgresado: 11,
  ExcluidoAltaServicio: 12,
  ProcesoDiscusion: 14,
});

export const compensatoryDocumentTypes = Object.freeze({
  MinutaServiciosCompensatorios20192020: 174,
  CertificacionVisita: 165,
  OtrosTitulo: 166,
  MinutaOfrecimiento: 173,
});

export const visitTypes = Object.freeze({
  UnSet: 0,
  VisitaRegular: 1,
  VisitaReposicion: 2,
  Ausencia: 3,
  Ausencia_Ofrecimiento: 4,
  Visita_Admision: 5,
  Visita_Plan: 6,
  Compensatorio_Reposicion: 7,
  Compensatorio_Regresion: 8,
  VisitaReposicion_AnoAnterior: 9,
  Ausencia_Ofrecimiento_AnoAnterior: 10,
  Compensatorio_Reposicion_Ausencia: 11,
  Visita_Paquete_Plan: 12,
});

export const compensatoryPeiCodes = Object.freeze({
  CuestionarioElegibilidad: 1872,
  Minuta: 857,
  Otros: 858,
  PlanillaElegibilidad: 1878,
  RechazoSolicitudHorasCompensatorias: 1925,
});

export const compensatoryDocCodes = Object.freeze({
  CuestionarioElegibilidad: 182,
  Minuta: 183,
  Otros: 184,
  PlanillaElegibilidad: 181,
  RechazoSolicitudHorasCompensatorias: 180,
});

//strategy number to add frequency and validForTheYear value
export const STRATEGY_5 = 25;

export const replacementStrategies = Object.freeze({
  Strategy1: 11,
  Strategy2: 12,
});

export const declineSources = Object.freeze({
  Request: 1,
  ClosingAnalysis: 2,
});
